import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateArquivosDiversosColumnDefinition
 */

type Props = {
  onActionEditar: (idAssistenciaArquivo: number, openNewTab: boolean) => void;
  onActionDelete: (idAssistenciaArquivo: number, openModal: boolean) => void;
  onActionDownload: (idAssistenciaArquivo: number, openNewTab: boolean) => void;
};

export const GenerateArquivosDiversosColumnDefinition = ({
  onActionEditar,
  onActionDelete,
  onActionDownload,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 80,
      sortable: false,
      align: 'left',
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Arquivo",
      width: 235,
      sortable: false,
      resizable: true,
      valueGetter: (_, rows) => ({
        idAssistenciaArquivo: rows['idAssistenciaArquivo'],
        nome: rows['nome'],
      }),
      renderCell: ({ value: { idAssistenciaArquivo, nome } }) => {
        return (
          <Button
            onMouseDown={e => {
              onActionDownload(idAssistenciaArquivo, true);
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #4b8df8',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
              width: Math.min(200, nome.length * 8 + 16),
            }}>
            {nome.length > 30 ? nome.substring(0, 23) + '...' + nome.substring(nome.length - 4) : nome}
          </Button>
        );
      },
    },
    {
      field: 'idAssistenciaArquivo',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}